<template>
<div>
         <div id="encabezados-tp">
            <h1>Control Auxiliar</h1>
            <h3></h3>
            <!-- <div class="hr-titulo"></div> -->
        </div>
           <div class="filtros-busqueda margen-main-GT">
             <input type="date" class='form-control campos' v-model="Fecha"/>
             <!-- </div> -->
             <button type="button" class="btn btn-info" @click="ObtenerAudiencias">Ir a Fecha</button>
        </div>

        <br><br>
    <div class="margen-main-GT">
           <h6></h6>
           <table 
                class="table table-striped table-light table-hover letra-grande"
                id='tabla-audiencas'             
                data-toggle="table"
                data-undefined-text=""               
                data-click-to-select="false"
                data-search="true"
                data-row-style=aplicarEstilosPorPartidoJudicial
                data-pagination="false"
                data-maintain-meta-data="true"
                data-page-size = "10"
                data-page-list="[5,10,20,30,40, 50, 60, 70, 80, 90, 100, 200, 300, 1000]"
                data-show-toggle="true"
                data-show-pagination-switch="true"
               
           >
           <thead  class="thead-dark">
               <tr>
                   <th data-halign="center"  data-align="center"  data-field="audiencia_id">FOLIO</th>
                   <th data-halign="center"  data-align="center"  data-field="partido_id">PARTIDO</th>
                    <th data-halign="center" data-align="center"  data-field="carpeta_alias">CARPETA</th>
                   <th data-halign="center"  data-align="center"  data-field="FechaDeAudiencia">FECHA DE AUDIENCIA</th>
                   <th data-halign="center"  data-align="center"  data-field="HoraDeAudiencia">HORA</th>
                   <th data-halign="center"  data-align="center"  data-field="Sala">SALA</th>
                   <th data-halign="center"  data-align="center"  data-field="zoom_id">ID ZOOM</th>
                   <th data-halign="center"  data-align="center"  data-field="audiencia_tipo">AUDIENCIA</th>
                   <th data-halign="center"  data-align="center"  data-field="audiencia_auxiliar">AUXILIAR</th>
                   <th data-halign="center"  data-align="center"  data-field="audiencia_1_juez">JUEZ</th>
                   <th data-events="operateEvents" data-halign="center" data-align="center"  data-field="BotonInicio">INICIO</th>
                   <th data-events="operateEvents" data-halign="center" data-align="center"  data-field="BotonFin">FIN</th>
                   <th data-events="operateEvents"  data-align="center"  data-field="RadioSi">PUNTUAL</th>
               </tr>
           </thead>

           </table>
       </div>

</div>
    
</template>

<script>
import axios from 'axios';
import api from '@/../static/js/api'
import comun from "@/../static/js/comun"
import {CATALOGOS} from "../Catalogos/CatalogosBD.js"
import moment from 'moment'

export default{
    data(){
            return{
                CATALOGOS,
                Fecha:moment().format('YYYY-MM-DD'),
            }
        },
    methods:{
     
        ObtenerAudiencias: async function(){
            let parametros = {
                Fecha: this.Fecha
            }
            const RESPUESTA = await axios.post(api.conexion+'Audiencias/AgendaControlAux/AgendaControlAuxInformatica',parametros,null);
            let datosTabla =await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias);
            $("#tabla-audiencas").bootstrapTable({data:await datosTabla });
            $("#tabla-audiencas").bootstrapTable("load",await datosTabla);
        },
        formatoAudienciasJuez:async function(doc){
            let documento
            documento = doc.map(c => {
                let docFormateado = c;
                var NombrePartido =CATALOGOS.partidoJudicial.filter(a=>a.llave==c.partido_id);
                docFormateado.BotonFin = (c.audiencia_terminada==null)?'<button id="btnFin" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fa fa-stop-circle"></i>&nbsp;Fin</button>':'<label>'+moment(c.audiencia_terminada,"YYYY-MM-DD HH:mm:ss").format("HH:mm")+'</label>';
                docFormateado.BotonInicio = (c.audiencia_iniciada==null)?'<button id="btnInicio" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fa fa-play-circle"></i>&nbsp;Inicio</button>':'<label>'+moment(c.audiencia_iniciada,"YYYY-MM-DD HH:mm:ss").format("HH:mm")+'</label>';
                docFormateado.RadioSi ='<fieldset><div style="float:left;margin-right:7px"><input type="radio" id="cSi" name="puntual'+c.audiencia_id+'" ><label for="cSi">Si</label></div>   <div><input type="radio" id="cNo" name="puntual'+c.audiencia_id+'" value="cNo"><label for="cNo">No</label></div></fieldset>';
               if(c.audiencia_inicio_puntual==1){
                    docFormateado.RadioSi ='<fieldset><div style="float:left;margin-right:7px"><input type="radio" id="cSi" name="puntual'+c.audiencia_id+'" checked><label for="cSi">Si</label></div>   <div><input type="radio" id="cNo" name="puntual'+c.audiencia_id+'" value="cNo"><label for="cNo">No</label></div> </fieldset>';

               }
               else if(c.audiencia_inicio_puntual==2){
                    docFormateado.RadioSi ='<fieldset><div style="float:left;margin-right:7px"><input type="radio" id="cSi" name="puntual'+c.audiencia_id+'" ><label for="cSi">Si</label></div>   <div><input type="radio" id="cNo" name="puntual'+c.audiencia_id+'" value="No" checked><label for="cNo">No</label></div></fieldset>';

               }
                docFormateado.FechaDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"Sin Información";
                docFormateado.HoraDeAudiencia = (c.audiencia_fecha!=null)?moment(c.audiencia_fecha,"YYYY-MM-DD HH:mm:ss").format("HH:mm"):"Sin Información";
                docFormateado.NombrePartido = NombrePartido[0].valor;
                docFormateado.FechaAgendada =(c.audiencia_registrada!=null)?moment(c.audiencia_registrada,"YYYY-MM-DD HH:mm:ss").format("DD-MM-YYYY"):"Sin Información";
                docFormateado.ConDetenido = (c.audiencia_detenido == 1)?"Si":"No";
                docFormateado.Sala = (c.audiencia_sala!=null)?(c.audiencia_modo!=null)?c.audiencia_sala+" "+c.audiencia_modo:c.audiencia_sala : (c.audiencia_modo!=null)?c.audiencia_modo:"";
                c.carpeta_alias = (CATALOGOS.tiposCarpetas.find(a => a.llave == c.carpeta_tipo_id) != null )
                ?CATALOGOS.tiposCarpetas.find(a => a.llave == c.carpeta_tipo_id).valor+c.carpeta_alias
                :c.carpeta_alias 
                docFormateado.partido = c.partido_id.toString();
                return docFormateado;
            });
            return documento;
        },
        AgregarInicio:async function(row){
             let parametros = {
                IdAudiencia: row.audiencia_id
            }
            const RESPUESTA =await axios.post(api.conexion+'Audiencias/AgendaControlAux/Inicio',parametros,null);
            if(!RESPUESTA.data.SiHayError) this.ObtenerAudiencias();
         //   $("#tabla-audiencas").bootstrapTable({data:await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias)});
         //   $("#tabla-audiencas").bootstrapTable("load",await this.formatoAudienciasJuez(await RESPUESTA.data.Audiencias));

        },
        AgregarFin:async function(row){
             let parametros = {
                IdAudiencia: row.audiencia_id
            }
            const RESPUESTA =await axios.post(api.conexion+'Audiencias/AgendaControlAux/Fin',parametros,null);
            if(!RESPUESTA.data.SiHayError) this.ObtenerAudiencias();
        },
        AgregarPuntualSi:async function(row){
             let parametros = {
                IdAudiencia: row.audiencia_id
            }
            const RESPUESTA =await axios.post(api.conexion+'Audiencias/AgendaControlAux/PuntualSi',parametros,null);
            console.log("respuesta",RESPUESTA);
        },
         AgregarPuntualNo:async function(row){
             let parametros = {
                IdAudiencia: row.audiencia_id
            }
            const RESPUESTA =await axios.post(api.conexion+'Audiencias/AgendaControlAux/PuntualNo',parametros,null);
            console.log("respuesta",RESPUESTA);
        },

        agregarAccionInicion:() => {

            var boton = '<button id="btnInicio" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fa fa-play-circle"></i>&nbsp;Inicio</button>';

        return boton;
        
        },
        agregarAccionFin:() => {
         return '<button id="btnFin" class="btn btn-sm btn-xs btn btn-info align-middle align-center"><i class="fa fa-stop-circle"></i>&nbsp;Fin</button>';
        
        },
         agregarAccionPuntual:() => {
         return '<div><input type="radio" id="cSi" name="drone" checked><label for="huey">Si</label></div>   <div><input type="radio" id="cNo" name="drone" value="No"><label for="dewey">No</label></div>';
        
        },
        formatearFecha(formato){
            const fecha = new Date();
            let fechaConFormato='';
            if(fecha.getDate() > 9){
               fechaConFormato= formato.replace('dd', fecha.getDate())
            }else{
               fechaConFormato= formato.replace('dd', '0'+fecha.getDate())
            }

            if((fecha.getMonth() + 1) > 9){
              fechaConFormato=  fechaConFormato.replace('mm', fecha.getMonth() + 1)
            }else{

              fechaConFormato=  fechaConFormato.replace('mm', '0'+(fecha.getMonth() + 1))
            }
            fechaConFormato = fechaConFormato.replace('yyyy', fecha.getFullYear())
          return fechaConFormato
        }
    },
    mounted(){
    },
     created(){
         window.operateEvents = {
         
    'click #btnInicio':(e, value, row, index) => {
        this.AgregarInicio(row);
    },
    'click #btnFin':(e, value, row, index) => {
        this.AgregarFin(row);
    },
    'click #cSi':(e, value, row, index) => {
        this.AgregarPuntualSi(row);
       
    },
    'click #cNo':(e, value, row, index) => {
         this.AgregarPuntualNo(row);
    }
     }
    }
}


</script>
<style scoped>

.margen-main-GT {
    padding: 0 3em 0 2em;
}
.letra-grande{
    font-size: 1.5em
}
.campos{
    width: 20%;
}
#encabezados-tp {
    margin-bottom: 4em;
    width: 100%;
    text-align: center;
    background-color: rgb(20, 20, 20);
    padding: 1em 0 0.5em 0;
}

#encabezados-tp h1 {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 2.5em;
}

#encabezados-tp h3 {
    font-size: 1.5em;
    color: rgb(175, 175, 175);
}

#encabezados-tp h4 {
    font-size: 1.5em;
    color: rgb(214, 214, 214);
}
.filtros-busqueda {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1em;
    flex-wrap: wrap;
}
</style>


// WEBPACK FOOTER //
// src/components/Audiencias/AgendaControlAuxInfromatica/AgendaControlAuxInformatica.vue